export default __webpack_public_path__ + "media/images/mailer/logo-8e3ce7a3e5ddd5fa5905c36915d5d8f1.png";